<!-- Reports List (similar style to staffs/zone list) -->
<div class="row mt-3">
  <div class="w-100 pl-4 pr-4 pt-2">
    @if (unFilteredReports.length > 0) {
      <!-- Search input -->
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search reports by report name"
          [(ngModel)]="searchQuery"
          (input)="filterReports()"
        />
      </div>
    }

    @if (reports.length > 0) {
      <table class="table text-left">
        <thead class="table-light">
          <tr class="bg-dark">
            <th scope="col" class="pb-3">Generated Date</th>
            <th scope="col" class="pb-3">Report Name</th>
            <th scope="col" class="pb-3">Type</th>
            <th scope="col" class="pb-3 text-center">Actions</th>
          </tr>
        </thead>
        <tbody class="bg-white">
          @for (report of reports; track report; let i = $index) {
            <tr class="border-bottom">
              <td>{{ report.generatedDate | date: 'MMM d, yyyy' }}</td>
              <td>{{ report.reportName }}</td>
              <td>
                {{
                  report.reportType == 'monthly_sales_report'
                    ? 'Monthly Sales Report'
                    : (report.reportType | titlecase)
                }}
              </td>
              <td class="actions-cell">
                <div class="action-buttons">
                  <button
                    type="button"
                    class="action-btn"
                    (click)="getPreSignedUrl(report, 'view')"
                    title="View report"
                  >
                    <i class="bx bx-show"></i>
                  </button>
                  <a
                    class="action-btn"
                    (click)="getPreSignedUrl(report, 'download')"
                    download
                    title="Download report"
                  >
                    <i class="bx bx-download"></i>
                  </a>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else if (unFilteredReports.length > 0) {
      <div
        class="d-flex flex-column align-items-center justify-content-center common-empty-container"
      >
        <p class="common-empty-header">No matching reports</p>
        <p class="common-empty-sub-text">Try a different search term.</p>
      </div>
    } @else {
      <div
        class="d-flex flex-column align-items-center justify-content-center common-empty-container"
      >
        <img src="assets/no-orders-yet.svg" alt="No Reports" class="common-empty-img mb-3" />
        <p class="common-empty-header">No Reports</p>
        <p class="common-empty-sub-text">Reports will appear here once generated.</p>
      </div>
    }
  </div>
</div>
